<div class="registration-add" fxLayout="column" fxLayoutGap="15px">
  <div fxLayout="row" fxFlex="100" fxLayoutGap="15px">
    <button (click)="save()" [class.spinner]="processingRequest"
            mat-stroked-button color="primary"><mat-icon>save</mat-icon> <span> Zapisz</span></button>
    <button (click)="cancel()" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>
  <div fxLayout="row" fxLayoutGap="15px" fxFlex="100" fxLayout.lt-lg="column">
    <div fxFlex="100" fxFlex.lt-md="100" fxLayoutGap="15px" fxLayout="column">
      <div fxLayout="row" fxFlex.lt-md="100" *ngIf="registrationObject.insuranceCompany.registrationIdTypes.length > 0">
        <div fxFlex="100">
          <mat-card *ngIf="!disable">
            <div fxLayout="row">
              <h3>Identifykatory</h3>
            </div>
            <div fxLayout="row wrap">
              <ng-container *ngFor="let typeKey of registrationObject.insuranceCompany.registrationIdTypes">
                <ng-container *ngIf="registrationIdForms.hasOwnProperty(typeKey) && typeKey!=REGISTRATION_ID_TYPE_SENT" >
                  <div
                    [fxFlex]="registrationIdForms[typeKey].typeDict.valueType === 'string' ? 96 : 96"
                    [formGroup]="registrationIdForms[typeKey].formGroup"
                  >
                    <ng-container *ngIf="registrationIdForms[typeKey].typeDict.valueType === 'string'">
                      <app-chips-input-control *ngIf=" typeKey ==='manager'
                      || typeKey ==='manager_email'
                      || typeKey ==='manager_phone'
                      || typeKey ==='generali_agro_ic_email'
                      || typeKey ==='generali_agro_ic_manager'
                      || typeKey ==='generali_agro_ic_phone' "
                                               [lastTest]="true"
                                               [label]="registrationIdForms[typeKey].identifierName"
                                               [arrayControl]="getControl(registrationIdForms[typeKey].formGroup, 'value')"  class="id-mat"
                      ></app-chips-input-control>
                      <app-chips-input-control *ngIf=" typeKey !=='manager'
                       && typeKey !=='manager_email'
                       && typeKey !=='manager_phone'
                       && typeKey !=='generali_agro_ic_email'
                       && typeKey !=='generali_agro_ic_manager'
                       && typeKey !=='generali_agro_ic_phone' "
                                               [lastTest]="false"
                                               [label]="registrationIdForms[typeKey].identifierName"
                                               [arrayControl]="getControl(registrationIdForms[typeKey].formGroup, 'value')" class="id-mat"
                      ></app-chips-input-control>
                    </ng-container>

                    <ng-container *ngIf="registrationIdForms[typeKey].typeDict.valueType === 'bool' && registrationIdForms[typeKey].typeDict.key !== FILE_TYPE_ANOTHER_MULTI && registrationIdForms[typeKey].typeDict.key !== REGISTRATION_ID_TYPE_REQUEST_FOR_DELETION_SENT && registrationIdForms[typeKey].typeDict.key !== REGISTRATION_ID_TYPE_CONSENT_TO_DUAL_REGISTRATION  ">
                      <div class="box0">
                        <div fxLayout="column" fxLayoutGap="15px">
                          <div fxLayout="row">
                            <app-slide-toggle
                              [header]="registrationIdForms[typeKey].identifierName"
                              [control]="getControl(registrationIdForms[typeKey].formGroup, 'value')"
                              [trueValue]="'Tak'"
                              [falseValue]="'Nie'"
                            ></app-slide-toggle>
                          </div>
                        </div>
                      </div>
                    </ng-container>
                  </div>
                  <span fxFlex="2"></span>
                </ng-container>
              </ng-container>
            </div>
          </mat-card>
        </div>
      </div>
    </div>
  </div>
</div>
